// CSRF: the JSON endpoints authenticate with the identity cookie, so every unsafe
// request has to carry the antiforgery token the layout renders on each page. The DOM
// is read on every call rather than cached because the token is per-page: a component
// that survives a navigation must not keep sending the previous page's token.
export function antiforgeryHeaders() {
    const token = document.querySelector('input[name="__RequestVerificationToken"]');
    return token && token.value ? { "RequestVerificationToken": token.value } : {};
}

export default antiforgeryHeaders;
